"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 4.5a.5.5 0 0 1 .5-.5c2.128 0 3.765.77 4.867 1.957C17.46 7.137 18 8.7 18 10.25s-.539 3.113-1.633 4.293C15.265 15.731 13.628 16.5 11.5 16.5H8.707l1.647 1.646a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708.708L8.707 15.5H11.5c1.872 0 3.235-.668 4.133-1.637C16.54 12.887 17 11.575 17 10.25s-.461-2.637-1.367-3.613C14.735 5.668 13.372 5 11.5 5a.5.5 0 0 1-.5-.5"
}), 'Returned');
//# sourceMappingURL=index.js.map